import React, { FC, useState } from "react";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Grid,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormPasswordField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const inputRender = (isInGrid: boolean) => {
    return (
      <FormControl
        variant="outlined"
        sx={{
          width: "100%",
          marginBottom: "10px",
          letterSpacing: !showPassword ? 1.5 : "normal", // ✅ Apply only when visible
          ...(isInGrid && {
            "& .MuiOutlinedInput-root": {
              border: "1px solid #c4c4c4",
              letterSpacing: !showPassword ? 1.5 : "normal",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            height: "36px",
            borderRadius: "5px",
            border: props.error ? "1px solid #d32f2f" : undefined,
            letterSpacing: !showPassword ? 1.5 : "normal",
          }),
          "& input:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px #fff inset",
            WebkitTextFillColor: "#000",
            background: "transparent",
            height: isInGrid ? "0px !important" : "auto !important",
            letterSpacing: !showPassword ? 1.5 : "normal",
          },
        }}
      >
        <OutlinedInput
          {...props}
          id={props?.id || "outlined-adornment-password"}
          type={showPassword ? "text" : "password"}
          placeholder={props.placeholder}
          onChange={(e: any) => {
            props?.onChange && props?.onChange(e);
          }}
          onBlur={(e: any) => {
            props?.onBlur && props?.onBlur(e);
          }}
          inputProps={{
            ...props?.inputProps,
          }}
          sx={{
            background: "#fff",
            letterSpacing: !showPassword ? 1.5 : "normal", // ✅ Apply only when visible
            ...props?.InputProps?.sx,
            ...(props?.isRounded && { borderRadius: "50px" }), // Applying custom styling for rounded corners
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
        {!!props?.error && (
          <FormHelperText error={props?.error}>
            {props?.helperText}
          </FormHelperText>
        )}
      </FormControl>
    );
  };

  return (
    <>
      {props?.label ? (
        <>
          <Grid item xs={12} sm={5} className={classes.labelBox}>
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {(props?.required || props?.isRequired) && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid
            item
            xs={12}
            sm={7}
            style={{
              paddingLeft: "0px",
            }}
          >
            {inputRender(true)} {/* Pass true to indicate it is inside Grid */}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormPasswordField;
